import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import { getMinutesOfToday } from "components/CustomTimePicker/utils";

export const isToday = compareDate => {
    if (compareDate === -1) return 0;
    // Verificando si la fecha del filtro es hoy
    const today = getTodayWithoutHourInMillis();
    if (compareDate < today) return -1;
    if (compareDate > today) return 1;
    return 0;
}

export const isPastSchedule = ({
    date, minutes
}) => {
    const minutesOfToday = getMinutesOfToday();
    const isTodayValue = isToday(date);
    return isTodayValue < 0 || (isTodayValue === 0 && minutesOfToday >= minutes);
    // 11:59 >= 12:00 (no es pasado) | 12:00 >= 12:00 (es pasado)
}